import { Quote } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { useSettings, mediaUrl } from "@/context/SettingsContext";
import { Reveal } from "@/components/Reveal";
import { SectionHead } from "@/components/SectionHead";

const RecruitTestimonials = () => {
  const { t } = useLanguage();
  const { settings } = useSettings();
  const r = t.recruit;
  const items = settings.content?.recruit_testimonials?.length ? settings.content.recruit_testimonials : r.testimonials;
  if (!items.length) return null;

  return (
    <section className="bg-forest py-24 text-white" data-testid="recruit-testimonials">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHead overline={r.testimonialsOverline} title={r.testimonialsTitle} accent={r.testimonialsAccent} light />
        <div className="mt-14 grid gap-6 md:grid-cols-3">
          {items.map((x, i) => (
            <Reveal key={i} delay={0.1 * i}>
              <figure className="flex h-full flex-col rounded-3xl border border-white/10 bg-white/5 p-7 backdrop-blur" data-testid={`recruit-testimonial-${i}`}>
                <Quote className="h-7 w-7 text-gold" />
                <blockquote className="mt-5 flex-1 text-base leading-relaxed text-white/90">{x.text}</blockquote>
                <figcaption className="mt-7 flex items-center gap-3">
                  {x.photo_url ? <img src={mediaUrl(x.photo_url)} alt={x.name} className="h-12 w-12 rounded-2xl object-cover" /> : <span className="font-display flex h-12 w-12 items-center justify-center rounded-2xl bg-gold text-base font-bold text-white">{x.name.split(/\s+/).map((w) => w[0]).slice(0, 2).join("").toUpperCase()}</span>}
                  <div>
                    <p className="font-display font-bold" data-testid={`recruit-testimonial-${i}-name`}>{x.name}</p>
                    <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/60">{x.role}</p>
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RecruitTestimonials;
